import type { ReduxState } from '../types/internal/ReduxState';

export default ({ sendBoxValue }: ReduxState): string => sendBoxValue;
